import { h } from 'preact'
import { useStateValue } from '../../state-management/store'
import { buildStepContainerStyles } from '../../shared/buildStyles'
import { Customization } from '../../models/customization'
import * as style from './style.css'

const pendingStyles: Customization = {
    scheduling_modal: {
        background_color_style: 'solid',
        colors: {
            background_color_1: 'white',
            background_color_2: 'white',
            text: 'white',
        },
    },
    scheduling_additional_features_and_fields: {
        enabled_maps: false,
        insurance: 'optional',
        additional_comments: 'optional',
        custom_redirect: {
            enabled: false,
            url: '',
            target: 'same_window',
        },
    },
}

const StepBody: preact.FunctionalComponent = ({ children }) => {
    const [{ isCustomizationReady, customization }] = useStateValue()

    let styles = ''

    if (customization) {
        styles = buildStepContainerStyles(customization)
    } else if (!isCustomizationReady) {
        styles = buildStepContainerStyles(pendingStyles)
    }

    return (
        <div class={style.stepBody}>
            {Boolean(styles) && <style data-testid="custom-styles">{styles}</style>}
            <div class={style.stepBodyContent}>{children}</div>
        </div>
    )
}

export default StepBody
